import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentTransportOrderStatusChainFacade } from './shipment-transport-order-status-chain.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';
import { TransportOrderIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderStatusChainGuard {
  constructor(
    private shipmentTransportOrderStatusChainFacade: ShipmentTransportOrderStatusChainFacade,
    private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$.pipe(
      switchMap((identifier: TransportOrderIdView) => {
        return loadStoreState(this.shipmentTransportOrderStatusChainFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderStatusChainFacade);
  }
}
